(function () {

    "use strict";

    angular.module("sphforms.app", [
        "ui.router",
        "angular.filter",
        "ngResource",
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngRoute',
        'ngSanitize',
        'ngMaterial',
        'material.components.expansionPanels',
        "pascalprecht.translate",
        "ngFileUpload",
        "sphforms.translate",
        "sphForms.auth",
        "sphforms.workflow",
        "sphforms.main",
        "solpheo"
    ]);

}());
